import React from 'react';
import PropTypes from 'prop-types';

import {
  Field,
} from 'redux-form';

const format = (haRespondido) => {
  if (!haRespondido) {
    return <span role="img" aria-label="Sin Asistencia">​➖</span>;
  }

  return (
    <span role="img" aria-label="Presente">✔️</span>
  );
};

const StudentsScoresTable = ({
  fields = {},
  meta: { error, submitFailed },
  onSort,
  items,
  sortColumn,
  sortType,
}) => {
  const readOnlyFields = true;

  return (
    <>
      <table className="table table-striped check-in">
        <thead>
          <tr>
            <th scope="col col-2">N&uacute;mero de documento</th>
            <th
              onClick={() => onSort({ sortColumn: 'nombre', sortType })}
              scope="col col-3"
            >
              Nombre{' '}
              <i
                className={
                  `fa fa-sort-alpha-${sortColumn === 'nombre' && sortType === 'desc' ? sortType : 'asc'}`
                }
                aria-hidden="true"
              />
            </th>
            <th
              onClick={() => onSort({ sortColumn: 'apellido', sortType })}
              scope="col col-3"
            >
              Apellido{' '}
              <i
                className={`fa fa-sort-alpha-${sortColumn === 'apellido' && sortType === 'desc' ? sortType : 'asc'}`}
                aria-hidden="true"
              />
            </th>
            <th scope="col col-2">Respuesta</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((tarea, index) => (
            <tr key={`${tarea}`} id={`${tarea}`} className={items[index] && items[index].deleted ? 'hidden' : ''}>
              <th className="col col-2">
                <div className="form" style={{ display: 'flex' }}>
                  <div
                    className="form__form-group-input-wrap form__form-group-input-wrap--error "
                    style={{ display: 'flex' }}
                  >
                    <Field
                      name={`${tarea}.numeroDocumento`}
                      component="input"
                      autoComplete="false"
                      type="text"
                      readOnly={readOnlyFields}
                      disabled={readOnlyFields}
                    />

                  </div>
                </div>
              </th>
              <th className="col col-3">
                <div className="form" style={{ display: 'flex' }}>
                  <div className="form__form-group-input-wrap form__form-group-input-wrap--error ">
                    <Field
                      name={`${tarea}.nombre`}
                      component="input"
                      autoComplete="false"
                      type="text"
                      readOnly={readOnlyFields}
                      disabled={readOnlyFields}
                    />
                  </div>
                </div>
              </th>
              <th className="col col-3">
                <div className="form" style={{ display: 'flex' }}>
                  <div className="form__form-group-input-wrap form__form-group-input-wrap--error ">
                    <Field
                      name={`${tarea}.apellido`}
                      component="input"
                      autoComplete="false"
                      type="text"
                      readOnly={readOnlyFields}
                      disabled={readOnlyFields}
                    />
                  </div>
                </div>
              </th>

              <th className="col col-2">
                <div className="form" style={{ display: 'flex' }}>
                  <div className="form__form-group-input-wrap form__form-group-input-wrap--error ">
                    {format(items[index] && items[index].haRespondido)}
                  </div>
                </div>
              </th>

            </tr>
          ))}
        </tbody>
      </table>
      {
        submitFailed && error && (
          <span className="form__form-group-error" style={{ marginBottom: '0.5rem' }}>
            {error}
          </span>
        )
      }
    </>
  );
};

StudentsScoresTable.propTypes = {
  onSort: PropTypes.func.isRequired,
  fields: PropTypes.shape({}).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  meta: PropTypes.shape({}),
  sortColumn: PropTypes.string,
  sortType: PropTypes.string,
};

StudentsScoresTable.defaultProps = {
  meta: {},
  sortColumn: 'nombre',
  sortType: 'asc',
};

export default StudentsScoresTable;
